module.exports = __webpack_public_path__ + "static/media/6_phones.07cfb060.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LandingPage/Components/Footer/img/6_phones.png
// module id = 69
// module chunks = 0